import { useLazyQuery,useMutation } from "@apollo/client/react"; import React, { useEffect, useMemo, useState } from 'react';
import 'moment/locale/es';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { PopoverModal } from '../../../components/popoverModal/PopoverModal';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import './listarMinutaGrilla.scss';
import moment from 'moment';
import { ListarMinutaGrillaHeader } from './ListarMinutaGrillaHeader';
import { ListarMinutaGrillaFilters } from './ListarMinutaGrillaFilters';
import { usePersistFilters } from '../../../hooks/usePersistFilters';
import { DELETE_MINUTA } from '../../../data/graphQL/mutations/ListarMinuta/deleteMinuta';
import { GET_ROLES_BY_USER } from "../../../data/graphQL/queries/Reclamos/getRolesByUserId";

import toast from 'react-hot-toast';
import { CircularProgress } from '@mui/material';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';
import { formatCurrency } from "../../../utils/mathUtils";

// Roles
const ROL_RESPONSABLE_ADV = 25;
const ROL_IT= 1;

export const ListarMinutaGrilla = ({ setChildrenAction }) => {
  const storageId = parseInt(sessionStorage.getItem('idUsuario'), 10);
  const navigate = useNavigate();

  const [allowedWrite, setAllowedWrite] = useState(false);
  const [delegaciones, setDelegaciones] = useState([]);
  const [listarMinutasGrilla, setListarMinutasGrilla] = useState([]);
  const [listarMinutasGrillaLoading, setListarMinutasGrillaLoading] = useState(false);
  const [sendLoading, setSendLoading] = useState(false);
  const [minutasSeleccionadas, setMinutasSeleccionadas] = useState([]);
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [openDlgDelete, setOpenDlgDelete] = useState(false);
  const [minutaDelete, setMinutaDelete] = useState('');
  const [refetchGrilla, setRefetchGrilla] = useState(true);
  const [eliminarMinuta, setEliminarMinuta] = useState(false);
  // flag para identificar según el estado qué columnas mostrar en la grilla
  const [columnasEstado, setColumnasEstado] = useState(0);
  const [periodoActivo, setPeriodoActivo] = useState(null);

  const ESTADO_PENDIENTE_FACTURAR = 'Pendiente Facturar';
  const ESTADO_EN_SAP = 'En SAP';

  const ID_ESTADO_EN_SAP = 1;

  const mesActualPrimerDia = moment().format("YYYY").toString() + '-' + moment().format("MM").toString() + '-01';
  const initFechaDesde = moment(mesActualPrimerDia).format("YYYY-MM-DD");
  const initFechaHasta = moment(initFechaDesde).add(1, 'months').add(-1, 'days').format("YYYY-MM-DD");

  const { filters, handleChangeFilters } = usePersistFilters({
    fechaDesde: moment(mesActualPrimerDia).format("YYYY-MM-DD"),
    fechaHasta: initFechaHasta,
    idDelegacion: 0,
    idEstado: 3, // pendiente facturar
    idPaciente: 0,
    idCliente: ''
  }, "listarMinutaGrillaFilters");

  const location = useLocation();
  const rutasStorage = localStorage.getItem('navigationRoutes');

  useEffect(() => {
    if (rutasStorage) {
      const rutas = JSON.parse(rutasStorage);
      const rutaQueSirve = location.pathname;
      setAllowedWrite(rutas?.find((ruta) => ruta.aplicaciones.find((app) => app.url == rutaQueSirve)
      )?.aplicaciones?.find((app) => app.url == rutaQueSirve).escritura);
    }
  }, [rutasStorage]);

  const [getUserRoles, { data: dataUserRoles, loading: userRolesLoading }] = useLazyQuery(GET_ROLES_BY_USER, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataUserRoles) return;
    setEliminarMinuta(dataUserRoles.rolesByUserId.filter((r) => r.id == ROL_RESPONSABLE_ADV || r.id == ROL_IT).length > 0);
  }, [dataUserRoles]);

  useEffect(() => {
    if (!userRolesLoading)
      getUserRoles();
  }, []);

  useEffect(() => {
    setChildrenAction(() =>
      <ListarMinutaGrillaHeader
        allowedWrite={allowedWrite}
        minutasSeleccionadas={minutasSeleccionadas}
        setRefetchGrilla={setRefetchGrilla}
        setSendLoading={setSendLoading}
        periodoActivo={periodoActivo}
        setPeriodoActivo={setPeriodoActivo} />

    );
  }, [
    setChildrenAction,
    minutasSeleccionadas,
    allowedWrite,
    periodoActivo]
  );

  const handleView = (row) => {
    navigate(location.pathname + '/detalle', {
      state: {
        allowedWrite: allowedWrite,
        dataRegistro: row
      }
    });
  };

  const [eliminarInuta, { loading: deleteMinutaLoading }] = useMutation(DELETE_MINUTA, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      if (data.deleteMinuta.success) {
        toast.success(data.deleteMinuta.valorEsperado);
        setOpenDlgDelete(false);
        setRefetchGrilla(true);
      } else {
        toast.error(data.deleteMinuta.valorEsperado);
      }
    }
  });

  const handleDelete = (row) => {
    setMinutaDelete(row);
    setOpenDlgDelete(true);
  };

  const disabledCheckbox = (row) => {
    return !allowedWrite ||
      row?.estadoMinuta != ESTADO_PENDIENTE_FACTURAR ||
      !row.check;

  };

  const handleSelectionModelChange = (ids) => {
    setRowSelectionModel(ids);
    if (ids.length > 0) {
      setMinutasSeleccionadas(listarMinutasGrilla.filter((row, index) => {
        return ids.includes(index + 1);
      }));
    } else {
      setMinutasSeleccionadas([]);
    }
  };

  const handleDeleteAccept = () => {
    eliminarInuta({
      variables: {
        minutaInput: {
          idEvaluacion: minutaDelete.idEvaluacion,
          idMinuta: minutaDelete.idMinuta,
          idUsuario: storageId,
          fechaAlta: minutaDelete.fechaAlta,
          idTipoServicio: 3
        }
      }
    });
  };

  const handleDeleteCancel = () => {
    setMinutaDelete(null);
    setOpenDlgDelete(false);
  };

  const initialColumns = [
    {
      headerName: '',
      field: 'action',
      cellClassName: 'grid-actions-column',
      minWidth: 20,
      maxWidth: 20,
      width: 20,
      sortable: false,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <>
            <PopoverModal>
              <div className='popover-modal-content'>
                <div onClick={() => handleView(row)} aria-hidden='true'
                  className='item-option clickable-option'>

                  <VisibilityIcon className='edit-icon' />
                  <span className='toggle-action'>Ver</span>
                </div>
                {
                  allowedWrite && row?.estadoMinuta == ESTADO_EN_SAP && !deleteMinutaLoading && eliminarMinuta && 
                  <div
                    onClick={() => handleDelete(row)} aria-hidden='true'
                    className='item-option clickable-option'
                    style={{ cursor: 'pointer' }}>

                    <DeleteOutlineIcon className='edit-icon' />
                    <span className='toggle-action'>Eliminar</span>
                  </div>
                }
                {
                  allowedWrite && row?.estadoMinuta == ESTADO_EN_SAP && deleteMinutaLoading &&
                  <div style={{ paddingLeft: '8px', color: 'gray' }}>
                    <CircularProgress size="22px" color="inherit" />
                  </div>
                }
              </div>
            </PopoverModal>
          </>);

      }
    },
    {
      field: 'idMinuta',
      headerName: 'Minuta',
      flex: 0.15
    },
    {
      field: 'paciente',
      headerName: 'Paciente',
      flex: 0.35
    },
    ...(columnasEstado === ID_ESTADO_EN_SAP ? [{
      field: 'codSAP',
      headerName: 'Cód SAP',
      flex: 0.18
    }] : []),
    {
      field: 'codClienteSAP',
      headerName: 'Cliente',
      flex: 0.18
    },
    {
      field: 'cliente',
      headerName: 'Nombre Cliente',
      flex: 0.4
    },
    {
      field: 'modulo',
      headerName: 'Prog.',
      flex: 0.15
    },
    {
      field: 'cantidadConexion',
      headerName: 'Cnxs',
      description: 'Conexiones',
      flex: 0.11
    },
    {
      field: 'fA',
      headerName: 'FA',
      flex: 0.10,
      valueGetter: (fA) => {
        return fA ? 'SI' : 'NO';
      }
    },
    {
      field: 'numeroFactura',
      headerName: 'Factura',
      flex: 0.25
    },
    {
      field: 'precioTotal',
      headerName: '$ Total',
      flex: 0.20,
      valueGetter: (precioTotal) => {
        return formatCurrency(precioTotal);
      }
    }];


  const initialColumnsFA = [
    {
      headerName: '',
      field: 'action',
      cellClassName: 'grid-actions-column',
      minWidth: 20,
      maxWidth: 20,
      width: 20,
      sortable: false,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <>
            <PopoverModal>
              <div className='popover-modal-content'>
                <div onClick={() => handleView(row)} aria-hidden='true'
                  className='item-option clickable-option'>

                  <VisibilityIcon className='edit-icon' />
                  <span className='toggle-action'>Ver</span>
                </div>
                {
                  allowedWrite && !deleteMinutaLoading &&
                  <div
                    onClick={() => handleDelete(row)} aria-hidden='true'
                    className='item-option clickable-option'
                    style={{ cursor: 'pointer' }}>

                    <DeleteOutlineIcon className='edit-icon' />
                    <span className='toggle-action'>Eliminar</span>
                  </div>
                }
                {
                  allowedWrite && deleteMinutaLoading &&
                  <div style={{ paddingLeft: '8px', color: 'gray' }}>
                    <CircularProgress size="22px" color="inherit" />
                  </div>
                }
              </div>
            </PopoverModal>
          </>);

      }
    },
    {
      field: 'idMinuta',
      headerName: 'Minuta',
      width: 70
    },
    {
      field: 'paciente',
      headerName: 'Paciente',
      width: 170
    },
    {
      field: 'codClienteSAP',
      headerName: 'Cliente',
      width: 85
    },
    {
      field: 'cliente',
      headerName: 'Nombre Cliente',
      width: 170
    },
    {
      field: 'modulo',
      headerName: 'Prog.',
      description: 'Programa',
      width: 55
    },
    {
      field: 'cantidadConexion',
      headerName: 'Cnxs',
      description: 'Conexiones',
      width: 55
    },
    {
      field: 'fA',
      headerName: 'FA',
      width: 40,
      valueGetter: (fA) => {
        return fA ? 'SI' : 'NO';
      }
    },
    {
      field: 'precioDiario',
      headerName: 'Precio Diario',
      headerAlign: 'right',
      width: 90,
      align: 'right',
      valueGetter: (precioDiario) => formatCurrency(precioDiario)
    },
    {
      field: 'precioSAP',
      headerName: 'Precio SAP',
      headerAlign: 'right',
      width: 90,
      align: 'right',
      valueGetter: (precioSAP) => formatCurrency(precioSAP)
    },
    {
      field: 'precioControl',
      headerName: 'Precio Ctrol',
      headerAlign: 'right',
      width: 90,
      align: 'right',
      valueGetter: (precioControl) => formatCurrency(precioControl)
    },
    {
      field: 'tipoPrecio',
      headerName: 'Tipo Precio',
      width: 110
    },
    {
      field: 'vigencia',
      headerName: 'Vigencia',
      width: 125
    },
    {
      field: 'precioTotal',
      headerName: 'Total',
      width: 100,
      valueGetter: (precioTotal) => formatCurrency(precioTotal)
    }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), [filters, allowedWrite, deleteMinutaLoading, columnasEstado, eliminarMinuta]);

  const columnsFA = useMemo(() => generateColumnsDefaultConfiguration(initialColumnsFA, true), [filters, allowedWrite, deleteMinutaLoading, columnasEstado]);

  return (
    <>
      <div>
        <ListarMinutaGrillaFilters
          delegaciones={delegaciones}
          filters={filters}
          sendLoading={sendLoading}
          setListarMinutasGrilla={setListarMinutasGrilla}
          setListarMinutasGrillaLoading={setListarMinutasGrillaLoading}
          setDelegaciones={setDelegaciones}
          handleChangeFilters={handleChangeFilters}
          refetchGrilla={refetchGrilla}
          setRefetchGrilla={setRefetchGrilla}
          setColumnasEstado={setColumnasEstado}
          periodoActivo={periodoActivo} />

        <br />
        <DataGridGenerico
          columns={columnasEstado != 3 ? columns : columnsFA}
          rows={listarMinutasGrilla}
          toolbar={false}
          // maxWidth={columnasEstado != 3 ?
          //   columns.reduce(
          //     (total, column) => total + (column.width || 0),
          //     0
          //   ) : columnsFA.reduce(
          //     (total, column) => total + (column.width || 0),
          //     0
          //   )}
          checkboxSelection={true}
          isRowSelectable={(param) => !disabledCheckbox(param.row)}
          onRowSelectionModelChange={handleSelectionModelChange}
          rowSelectionModel={rowSelectionModel}
          loading={listarMinutasGrillaLoading} />

      </div>
      <Outlet />
      <CustomDialog
        maxWidth="md"
        open={openDlgDelete}
        title={"Eliminación de Minuta"}
        onCancel={handleDeleteCancel}
        cancelDisabled={deleteMinutaLoading}
        onAccept={handleDeleteAccept}
        acceptLoading={deleteMinutaLoading}>

        <span>
          ¿Confirma que desea <strong>eliminar la minuta {minutaDelete != null ? minutaDelete.idMinuta : ""}</strong> y <strong>volver las conexiones a su estado original</strong>?.<br /><br />
        </span>
      </CustomDialog>
    </>);

};